import { useSelector } from 'react-redux';

const norm = (s) => String(s || '').trim().toLowerCase();

export function useCan() {
  const { permissions = {} } = useSelector((s) => s.auth || {});
  const can = (permissionName, action = 'read') => {
    const p = permissions[norm(permissionName)];
    const a = norm(action);

    if (!p) return false;

    // shape 1: object with booleans
    if (p && typeof p === 'object' && !Array.isArray(p)) {
      return !!p[a];
    }
    // shape 2: array of actions
    if (Array.isArray(p)) {
      return p.map(norm).includes(a);
    }
    return false;
  };

  const canRead = (perm) => can(perm, 'read');
  const canCreate = (perm) => can(perm, 'create');
  const canModify = (perm) => can(perm, 'modify');
  const canDelete = (perm) => can(perm, 'delete');

  return { can, canRead, canCreate, canModify, canDelete };
}